import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

function About() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <div className="about-hero-badge">
            <svg className="badge-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
            Our Story
          </div>
          <h1>Built by Car Enthusiasts, <br/>For Busy People</h1>
          <p className="about-hero-text">
            What began with two automotive enthusiasts quickly grew into a mission.
            After years of waiting in endless lines just to get a simple oil change,
            we realized there had to be a better way.
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="about-story-section">
        <div className="section-container">
          <div className="story-grid">
            <div className="story-content">
              <h2>The NorCal Mobile Oil Change Story</h2>
              <p>
                As the saying goes, "If you want something done right, do it yourself." So we did.
                We're not trying to reinvent the wheel. We're building a service around one core principle:
              </p>
              <div className="highlight-box">
                <svg className="highlight-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
                <span>Your time matters.</span>
              </div>
              <p>
                That idea became the foundation of our approach and the inspiration behind our name —
                <strong> NorCal Mobile Oil Change</strong>, serving Northern California with convenience.
              </p>
              <p>
                With modern equipment, reliable processes, and strict time management, we make vehicle care
                fast, efficient, and stress-free. Our goal is simple: provide professional, convenient service
                right at your doorstep.
              </p>
            </div>
            <div className="story-image">
              <img src="/images/norcal-phone.jpg" alt="NorCal Mobile Oil Change service" />
              <div className="image-badge">
                <span className="badge-year">2024</span>
                <span className="badge-label">Est.</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-values-section">
        <div className="section-container">
          <h2>Why Choose NorCal Mobile Oil Change?</h2>
          <p className="section-subtitle">What sets us apart from traditional auto shops</p>

          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <h3>We Come to You</h3>
              <p>Convenient mobile solutions — we come to your home, office, or wherever you are</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
                </svg>
              </div>
              <h3>Modern Equipment</h3>
              <p>Reliable, professional-grade tools for quality service every time</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
              </div>
              <h3>Time-Conscious</h3>
              <p>Responsible specialists who value your time as much as you do</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  <polyline points="9 12 11 14 15 10"/>
                </svg>
              </div>
              <h3>Professional Service</h3>
              <p>Fast, transparent, and professional service every visit</p>
            </div>
          </div>
        </div>
      </section>

      {/* Founders Section */}
      <section className="about-founders-section">
        <div className="section-container">
          <h2>Meet the Founders</h2>
          <p className="section-subtitle">The team behind NorCal Mobile Oil Change</p>

          <div className="founders-grid">
            <div className="founder-card">
              <div className="founder-avatar">D</div>
              <h3>Denis Divakov</h3>
              <p className="founder-role">Co-Founder</p>
              <p className="founder-bio">
                Automotive enthusiast with a passion for efficiency and customer service.
                Denis brings technical expertise and hands-on experience to every service.
              </p>
            </div>
            <div className="founder-card">
              <div className="founder-avatar">I</div>
              <h3>Iurii Vadaturschii</h3>
              <p className="founder-role">Co-Founder</p>
              <p className="founder-bio">
                Operations specialist focused on delivering exceptional customer experiences.
                Iurii ensures every interaction is smooth and professional.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Motto Section */}
      <section className="about-motto-section">
        <div className="section-container">
          <div className="motto-content">
            <div className="motto-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <path d="M12 6v6l4 2"/>
              </svg>
            </div>
            <h2>NorCal Mobile Oil Change</h2>
            <p className="motto-tagline">We Come To You!</p>
            <p className="motto-description">
              Your time is valuable — and we're here to respect it.
            </p>
            <Link to="/" className="motto-cta">
              Book Your Service
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"/>
                <polyline points="12 5 19 12 12 19"/>
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
